import { Inject, Injectable } from '@angular/core';
import { FilterServiceInterface } from './service.class';
import { HttpClient, HttpParams } from '@angular/common/http';
import { GetManyResponseInterface } from '../../model/interface/crud-response-interface.model';
import { ActivityTypeInterface } from '../../model/interface/activities.model';

@Injectable({
  providedIn: 'root',
})
export class ActivityTypeService implements FilterServiceInterface {
  constructor(public http: HttpClient, @Inject('API_BASE_URL') private readonly baseUrl: string) {}

  public getData(options?: HttpParams): Promise<ActivityTypeInterface[]> {
    return new Promise((resolve, reject) => {
      this.http
        .get(`${this.baseUrl}/activity-type`, { params: options })
        .subscribe((response: GetManyResponseInterface<ActivityTypeInterface>) => {
          if (response.hasOwnProperty('data')) {
            resolve(response.data);
          } else {
            reject();
          }
        });
    });
  }
}
